module.exports = __webpack_public_path__ + "static/media/foodtruck-min.d4d69cf1.mp4";